import {Route} from "react-router-dom";
import ComingSoon from "./components/ComingSoon";
import {ProjectProvider} from "./contexts/ProjectContext";
import PageNotFound from "./components/common/PageNotFound";
import React, {lazy} from "react";
import SpiEmailDispatcher from "./components/private/project/spi_email_dispatcher/SpiEmailDispatcher";
const Projects = lazy(() => import('./components/private/Projects'));
const PendingActions = lazy(() => import("./components/private/PendingActions"))
const PendingAction = lazy(() => import("./components/private/PendingAction"))
const ProjectPage = lazy(() => import('./components/private/ProjectPage'));
const ExecutiveDashboard = lazy(() => import('./components/private/project/executive-dashboard/ExecutiveDashboard'));
const ProductionDashboard = lazy(() => import('./components/private/project/production-dashboard/ProductionDashboard'));
const PerformanceDashboard = lazy(() => import('./components/private/project/performance-dashboard/PerformanceDashboard'));
const PrecautionsDashboard = lazy(() => import('./components/ComingSoon'));
const Forms = lazy(() => import('./components/private/project/data-entry/forms/Forms'));
const CreateUpdateForm = lazy(() => import('./components/private/project/data-entry/forms/CreateUpdateForm'));
const Reports = lazy(() => import('./components/private/project/reports/Archive'));
const DocumentRegister = lazy(() => import('./components/private/project/document_register/DocumentRegister'));
const DowntimeRegister = lazy(() => import('./components/private/project/downtime_register/DowntimeRegister'));
const ExecutiveReport = lazy(() => import('./components/private/project/reports/executive-report/ExecutiveReport'));
const DailyReport = lazy(() => import('./components/private/project/reports/daily-report/DailyReport'));
const PlanningLoadSheet = lazy(() => import('./components/private/project/data-entry/loadsheet/PlanningLoadsheet'));
const DowntimeLoadsheet = lazy(() => import('./components/private/project/data-entry/loadsheet/DowntimeLoadsheet'));

export default function APMRoutes(){

    return (
        <>
            <Route index path="/"  element={<Projects/>}/>
            <Route path="/projects/" element={<Projects/>}/>
            <Route path="/coming-soon" element={<ComingSoon/>}/>
            <Route path="/pending-actions" element={<PendingActions/>}/>
            <Route path="/projects/:projectId/subproject/:subProjectId/template/:template_id/spi-email-dispatcher" element={<ProjectProvider><SpiEmailDispatcher/></ProjectProvider>}/>
            <Route
                path="/projects/:projectId/subproject/:subProjectId/pending-actions/:type/:resourceId/request/:id"
                element={<ProjectProvider><PendingAction/></ProjectProvider>}
            />
            <Route path="/projects/:projectId/" element={<ProjectProvider><ProjectPage/></ProjectProvider>}/>
            <Route path="/projects/:projectId/executive-dashboard/" element={<ProjectProvider><ExecutiveDashboard/></ProjectProvider>}/>
            <Route path="/projects/:projectId/production-dashboard/" element={<ProjectProvider><ProductionDashboard/></ProjectProvider>}/>
            <Route path="/projects/:projectId/performance-dashboard/" element={<ProjectProvider><PerformanceDashboard/></ProjectProvider>}/>
            <Route path="/projects/:projectId/precautions-dashboard/" element={<ProjectProvider><PrecautionsDashboard/></ProjectProvider>}/>
            <Route path="/projects/:projectId/reports" element={<ProjectProvider><Reports/></ProjectProvider>}/>
            <Route path="/projects/:projectId/document-register" element={<ProjectProvider><DocumentRegister/></ProjectProvider>}/>
            <Route path="/projects/:projectId/downtime-register" element={<ProjectProvider><DowntimeRegister/></ProjectProvider>}/>
            <Route path="/projects/:projectId/data-entry/forms/" element={<ProjectProvider><Forms/></ProjectProvider>}/>
            <Route path="/projects/:projectId/data-entry/planning-budget-load-sheet/" element={<ProjectProvider><PlanningLoadSheet/></ProjectProvider>}/>
            <Route path="/projects/:projectId/data-entry/downtime-load-sheet/" element={<ProjectProvider><DowntimeLoadsheet/></ProjectProvider>}/>
            <Route
                path="/projects/:projectId/data-entry/forms/:type/:templateId/new"
                element={<ProjectProvider><CreateUpdateForm/></ProjectProvider>}
            />
            <Route
                path="/projects/:projectId/data-entry/working-form/sub-project/:subProjectId/:type/:id"
                element={<ProjectProvider><CreateUpdateForm/></ProjectProvider>}
            />
            <Route
                path="/projects/:projectId/sub-project/:subProjectId/reports/executive-report/:id"
                element={<ProjectProvider><ExecutiveReport/></ProjectProvider>}
            />
                <Route
                path="/projects/:projectId/sub-project/:subProjectId/reports/daily-report/:id"
                element={<ProjectProvider><DailyReport/></ProjectProvider>}
            />
            <Route path="*" element={<PageNotFound/>}/>
        </>
    )
}